import type { Timestamp } from 'firebase/firestore';

export function formatTimestamp(ts: Timestamp | null | undefined, format: 'full' | 'short' | 'relative' = 'full'): string {
  if (!ts) return 'N/A';
  const date = ts.toDate();

  if (format === 'relative') {
    const diff = Date.now() - date.getTime();
    if (diff < 60000) return '방금 전';
    if (diff < 3600000) return `${Math.floor(diff / 60000)}분 전`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}시간 전`;
    return `${Math.floor(diff / 86400000)}일 전`;
  }

  const pad = (n: number) => String(n).padStart(2, '0');
  const y = date.getFullYear();
  const m = pad(date.getMonth() + 1);
  const d = pad(date.getDate());
  const h = pad(date.getHours());
  const min = pad(date.getMinutes());
  const s = pad(date.getSeconds());

  if (format === 'short') return `${m}-${d} ${h}:${min}`;
  return `${y}-${m}-${d} ${h}:${min}:${s}`;
}

export function timestampToMs(ts: Timestamp | null | undefined): number {
  return ts?.toMillis?.() ?? 0;
}

export const ONLINE_THRESHOLD_MINUTES = 10;

export function isUserActiveNow(
  lastActiveAt: Timestamp | null | undefined,
  thresholdMinutes: number = ONLINE_THRESHOLD_MINUTES,
): boolean {
  const ms = timestampToMs(lastActiveAt);
  if (!ms) return false;
  return Date.now() - ms <= thresholdMinutes * 60 * 1000;
}
